import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
    class: "field",
    style: { "text-align": "right" }
};
const _hoisted_2 = { class: "control is-small" };
export default /*#__PURE__*/ _defineComponent({
    __name: 'SaveButton',
    props: {
        action: {},
        inProgressAction: {},
        label: {},
        icon: {},
        iconRight: { type: Boolean },
        large: { type: Boolean }
    },
    emits: ['click'],
    setup(__props, { emit: __emit }) {
        // Event for two-way binding
        const emit = __emit;
        const onClick = () => {
            emit('click');
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("button", {
                        type: "submit",
                        value: "Save",
                        class: _normalizeClass(["formButton button is-link", { 'is-small': !_ctx.large, 'is-loading': _ctx.action && (_ctx.inProgressAction == _ctx.action) }]),
                        onClick: _cache[0] || (_cache[0] = ($event) => (onClick()))
                    }, [
                        (_ctx.icon && !_ctx.iconRight)
                            ? (_openBlock(), _createElementBlock("i", {
                                key: 0,
                                class: _normalizeClass(["fa mr-2", _ctx.icon])
                            }, null, 2))
                            : _createCommentVNode("", true),
                        _createElementVNode("span", null, _toDisplayString(_ctx.label ? _ctx.label : 'Save'), 1),
                        (_ctx.icon && _ctx.iconRight)
                            ? (_openBlock(), _createElementBlock("i", {
                                key: 1,
                                class: _normalizeClass(["fas ml-2", _ctx.icon])
                            }, null, 2))
                            : _createCommentVNode("", true)
                    ], 2)
                ])
            ]));
        };
    }
});
